import { memberPermissionsQueryKeys } from './memberPermissionsQueryKeys.js';

const memberPermissionsQueryPredicates = {
  byResourceId: (q, listId) => {
    const targetKey = memberPermissionsQueryKeys.byResourceId(listId);
    return q.queryKey[0] === targetKey[0] && q.queryKey[1] === targetKey[1];
  }
};

export { memberPermissionsQueryPredicates };
//# sourceMappingURL=memberPermissionsQueryPredicates.js.map
